import React, { useMemo } from "react"

import { NETWORK_STATUS_CONFIG } from "one-verify/src/config/networkStatus.config.ts"
import { ButtonDropdownElement } from "one-verify/src/elements/buttonDropdown.element.tsx"

import { RuntimeHelper } from "../../../helpers/runtime.helper"
import { useAppDispatch } from "../../../store/appDispatch.hook"
import { useAppSelector } from "../../../store/selectors/app.selector"
import { networkStatusSelector } from "../../../store/selectors/networkStatus.selector"
import { runtimeSelector } from "../../../store/selectors/runtime.selector"
import { selectedPracticeRoleSelector } from "../../../store/selectors/selectedPracticeRole.selector"
import { networkStatusExportRulesList } from "../../../store/thunks/networkStatus.thunks"

import chevronDownIcon from "@front-shared/assets/images/icons/chevron-down-dark.svg"

export const RulesListCsvDropdownComponent: React.FunctionComponent<
    IRulesListCsvDropdownComponentProps
> = props => {
    const dispatch = useAppDispatch()

    const selectedPracticeRole = useAppSelector(selectedPracticeRoleSelector)
    const networkStatusState = useAppSelector(networkStatusSelector)
    const runtimeState = useAppSelector(runtimeSelector)

    const isExportLoading = useMemo<boolean>(() => {
        return RuntimeHelper.isNetworkStatusExportRulesLoading()
    }, [runtimeState.isLoading])

    const handleDownloadTemplate = () => {
        window.open(
            NETWORK_STATUS_CONFIG.csvTemplateUrl,
            "_blank",
            "noopener,noreferrer",
        )
    }

    const handleDownloadRulesAsCsv = () => {
        if (!selectedPracticeRole || !props.selectedRulesVersion) {
            return
        }

        dispatch(
            networkStatusExportRulesList({
                practice: selectedPracticeRole.practice,
                payload: {
                    version: props.selectedRulesVersion,
                    filters: networkStatusState.filters,
                },
            }),
        )
    }

    return (
        <ButtonDropdownElement
            buttonLabel={`CSV${
                isExportLoading
                    ? ` (${networkStatusState.exportProgress}%)`
                    : "..."
            }`}
            buttonType="default"
            buttonIcon={chevronDownIcon}
            buttonIsRightIcon
            buttonIsLoading={isExportLoading}
            dropdownClassName="min-w-[240px]"
            className="ml-[8px]"
            buttonClassName="
                rounded-[22px] px-[16px] py-[13px]
                bg-brand-warmLight border border-solid
                border-brand-primary hover:bg-brand-lilacLight
            "
            options={[
                {
                    label: "Download CSV template",
                    onClick: handleDownloadTemplate,
                },
                {
                    label: "Upload rules with CSV",
                    onClick: props.onOpenBulkUpload,
                },
                {
                    label: "Download rules as CSV",
                    onClick: handleDownloadRulesAsCsv,
                    isDisabled: !props.selectedRulesVersion,
                },
            ]}
        />
    )
}

interface IRulesListCsvDropdownComponentProps {
    selectedRulesVersion: number | null
    onOpenBulkUpload: () => void
}
